import React, { useState, useEffect, useRef } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, DateField
} from 'react-admin';
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
// import CustomFilter from './components/CustomFilter';
import moment from 'moment'
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomExportButton from './components/CustomExportButton';
import queryString from 'query-string';
import config from "./config.json";
import DisplayColumnsButton from './components/DisplayColumnsButton';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import CustomPagination from './components/CustomPagination';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import { hideVehicleNumber } from "./sharedData";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
    },
    searchParamsTitle: {
        fontSize: "1.05rem",
        color: "#7076839e"
    },
    searchParams: {
        fontFamily: "Poppins-Regular",
        fontSize: "0.95rem",
        color: "#7076839e"
    },

});

const CATEGORY = "DEVICE WALLET TRANSACTIONS SECTION"
//const searchTypes = ["Mobile Number", "Vehicle Number"];
const DEVICE_WALLET_TRANSACTIONS_COLUMNS = {
    "Parking Name": true,
    "Serial Number": true,
    "Device Name": true,
    "Amount": true,
    "Status": true,
    "Type": true,
    "Time": true,
    "Vehicle Number": true
};
export const DeviceWalletsTransactionsList = (props) => {
    const eventTracker = UseAnalyticsEvent()
    const classes = useStyles();
    const location = useLocation()
    const listDataRef = useRef();
    //const notify = useNotify()
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    let searchTypeState = ["Serial Number", "Vehicle Number", "Device Name"]
    const [search, setSearch] = useState(prevSearch.inputSearch)
    const [searchType, setSearchType] = useState(prevSearch.type ? prevSearch.type : "Serial Number");
    const [displayColumns, setDisplayColumns] = useState(DEVICE_WALLET_TRANSACTIONS_COLUMNS);

    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const filter = { search: { value: search, type: searchType }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", };

    const renderPaymentStatus = (record) => {
        return (
            <div
                className={classes.chipCell}
                style={{ color: record.status === "SUCCESS" || record.status === "TRANSFERRED" ? "#18cc69" : "#555555", backgroundColor: record.status === "SUCCESS" || record.status === "TRANSFERRED" ? "#18cc6919" : "#55555519" }}
            >
                {record.status}
            </div>
        )
    }

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };

    const getExportFile = (fileType) => {
        const {current : {total, currentSort, filterValues}} = listDataRef
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/v2/rfidLogs?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/${fileType}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                const timeFormat = "Do MMM YYYY (h:mm A)";
                let startTime = filter.start_time;
                if (startTime)
                    startTime = moment(startTime).format(timeFormat);
                else
                    startTime = moment().startOf("day").format(timeFormat);
                let endTime = filter.end_time;
                if (endTime)
                    endTime = moment(endTime).format(timeFormat);
                else
                    endTime = moment().endOf("day").format(timeFormat);

                tempLinkElement.setAttribute('download', `${startTime} - ${endTime} - ${currentParking && currentParking.name ? currentParking.name : "Permit Logs"}.${fileType}`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    const getExcelFile = () => {
        getExportFile("xlsx");
    };

    useEffect(() => {
        eventTracker(CATEGORY, " WALLET TRANSACTIONS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter && <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />}

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>

            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchType} setSearchTypes={setSearchType} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
                <DisplayColumnsButton defaultColumns={DEVICE_WALLET_TRANSACTIONS_COLUMNS} displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
                <CustomExportButton getCSV={getExcelFile} disabled={listDataRef.current && listDataRef.current.total === 0} />
            </div>
            {
                <div style={{ color: "#8097B1", fontSize: 12, marginTop: 10 }}>
                    Showing Results for:{" "}
                    {startDateTimeFilter && endDateTimeFilter ?
                        (`${moment(startDateTimeFilter).format("MMM Do, YYYY hh:mm a")} - ${moment(endDateTimeFilter).format("MMM Do, YYYY hh:mm a")}`)
                        :
                        (`${moment().format("MMM Do, YYYY")} 12:00 AM - 11:59 PM`)}
                </div>
            }
            <List
                {...props}
                style={{marginTop: 20}}
                empty={false}
                title="DWallets Transactions"
                bulkActionButtons={false}
                exporter={false}
                filter={filter}
                sort={{ field: 'created_on', order: 'DESC' }}
                actions={false}
                pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}}/>}
            >
                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.serial_number.toUpperCase()}
                        secondaryText={record => (<div>
                            {displayColumns["Device Name"] && record.unique_user_id && <div><span style={{ color: "#5a5a5a" }}>Device Name: </span>{record.unique_user_id}</div>}
                            {displayColumns["Parking Name"] && record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            {displayColumns["Amount"] && record.amount && <div style={{ color: (record.status === "SUCCESS" || record.status === "TRANSFERRED") && record.amount > 0 ? customTheme.palette.error.main : record.status === "SUCCESS" && record.amount < 0 ? customTheme.palette.error.main : "#555555" }}><span style={{ color: "#5a5a5a" }}>Amount: </span>{record.amount} Rs</div>}
                            {displayColumns["Status"] && record.status && <div style={{ color: record.status === "SUCCESS" || record.status === "TRANSFERRED" ? "#18cc69" : "#555555" }}><span style={{ color: "#5a5a5a" }}>Status: </span>{record.status}</div>}
                            {displayColumns["Time"] && record.created_on && <div><span style={{ color: "#5a5a5a" }}>Time: </span>{renderTime(record.created_on)}</div>}
                            {displayColumns["Vehicle Number"] && record.vehicle_number && <div><span style={{ color: "#5a5a5a" }}>Vehicle No: </span>{hideVehicleNumber(record.vehicle_number)}</div>}

                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>

                        {displayColumns["Serial Number"] && <TextField source="serial_number" label="Serial Number" />}
                        {displayColumns["Device Name"] && <TextField source="unique_user_id" label="Device Name" />}
                        {displayColumns["Vehicle Number"] &&  <FunctionField source="vehicle_number" label="Vehicle Number" render={record => record && record["vehicle_number"] !== null ? hideVehicleNumber(record["vehicle_number"]) : "-"} />}
                        {displayColumns["Parking Name"] && <TextField source="parking_name" label="Parking Name" />}
                        {displayColumns["Amount"] && <FunctionField
                            source="amount"
                            label="Amount"
                            render={record => {
                                let color = "#555", sign = "";
                                if (record.status === "SUCCESS" || record.status === "TRANSFERRED") {
                                    if (record.amount > 0) {
                                        sign = "+";
                                        color = customTheme.palette.success.main;
                                    } else if (record.amount < 0) {
                                        sign = "-";
                                        color = customTheme.palette.error.main;
                                    }
                                }
                                const amount = Math.abs(record.amount);
                                return <div style={{ color: color }}>
                                    <p>{sign} ₹{amount}</p>
                                </div>
                            }}
                            style={{ display: "flex", justifyContent: "center" }}
                            sortable={true}
                        />}
                        {displayColumns["Status"] && <FunctionField
                            source="status"
                            label="Status"
                            render={(record) => record && renderPaymentStatus(record)}
                            sortable={true}
                            style={{ display: "flex", justifyContent: "center" }}
                        />}
                        {displayColumns["Type"] && <FunctionField
                            source="type"
                            label="Type"
                            render={(record) => record && typeof record.type === "string" ? record.type.replace("_", " ") : null}
                            sortable={true}
                            style={{ display: "flex", justifyContent: "center", textAlign: "center", color: customTheme.palette.secondary.main }}
                        />}
                        {displayColumns["Time"] && <DateField source="created_on" label="Time" showTime={true} />}
                        {/* {displayColumns["Vehicle Number"] && <TextField source="vehicle_number" label="Vehicle Number" />} */}
                    </Datagrid>
                }
            </List>
        </div>
    )
};